import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { TextField } from '@shared/data/entity/fields/TextField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import classNames from './TextCollectionViewField.module.css';

interface Props {
  field: TextField;
  style?: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
  numberOfLines?: number;
}

const defaultStyle: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function TextCollectionViewField({
  field,
  style,
  textStyle,
  numberOfLines = field.multiline ? 4 : 2,
}: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[defaultStyle, style]}>
      <Text
        size="body1"
        numberOfLines={numberOfLines}
        className={field.multiline && classNames.multiline}
        style={textStyle}
      >
        {field.value}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
